












import { Component, Vue } from 'vue-property-decorator';

  @Component({
    filters: {
      padZero(number: number) : string {
        if (number < 10) {
          return `0${number}`;
        }
        return `${number}`;
      },
    },
  })
export default class Countdown extends Vue {
    private days: number = 0;

    private hours: number = 0;

    private minutes: number = 0;

    private seconds: number = 0;

    private timer: number = -1;

    tick() {
      const base = new Date(2020, 8, 5, 14, 0, 0);
      const now = new Date();

      let distance = Math.floor((now.getTime() - base.getTime()) / 1000);

      this.seconds = distance % 60;
      distance = Math.floor(distance / 60);
      this.minutes = distance % 60;
      distance = Math.floor(distance / 60);
      this.hours = distance % 24;
      this.days = Math.floor(distance / 24);
    }

    created() {
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }

    destroyed() {
      clearInterval(this.timer);
    }
}
